import React from 'react';

import { ErrorMessage } from '@eika/attention-message';

import { useTranslation } from '../../../translations';

const AntiMoneyLaunderingError = () => {
    const { antiMoneyLaunderingTask } = useTranslation();
    return (
        <ErrorMessage
            header={antiMoneyLaunderingTask.ahvTaskError.title}
            text={antiMoneyLaunderingTask.ahvTaskError.description}
        />
    );
};

export default AntiMoneyLaunderingError;
